export default {
  'Custom': 'कस्टम',
  'Original': 'मूल',
  'Resolution': 'रिज़ॉल्यूशन',
  'Frame rate': 'फ्रेम रेट',
  'The higher the frame rate, the smoother the animation': 'फ्रेम रेट जितना ज़्यादा होगा, एनीमेशन उतना ही सुचारु होगा।',
  'Start': 'शुरू करें',
  'End': 'समाप्त करें',
  'Create GIF': 'GIF बनाएं',
  'Download GIF': 'GIF डाउनलोड करें',
  'Create A New One': 'नया बनाएं',
  'Remake GIF': 'GIF रीमेक करें',
  'HitPaw Video to GIF Online': 'HitPaw ऑनलाइन वीडियो से गिफ',
  'Upload and convert video to GIF without any difficulty': 'अपलोड करें और आसानी से वीडियो से गिफ में बदलें',
}